import { Controller } from "stimulus"

let groupDailyWorkloadingsDayChart;
let groupDailyWorkloadingsPlanningDayChart;
let groupDailyWorkloadingsBuildingDayChart;
let groupDailyWorkloadingsNonConstructionDayChart;

export default class extends Controller {
  connect() {
    groupDailyWorkloadingsDayChart = echarts.init(document.getElementById('group-daily-workloadings-day-chart'));
    groupDailyWorkloadingsPlanningDayChart = echarts.init(document.getElementById('group-daily-workloadings-planning-day-chart'));
    groupDailyWorkloadingsBuildingDayChart = echarts.init(document.getElementById('group-daily-workloadings-building-day-chart'));
    groupDailyWorkloadingsNonConstructionDayChart = echarts.init(document.getElementById('group-daily-workloadings-non-construction-day-chart'));

    const beginDate = this.data.get("begin_date");
    const endDate = this.data.get("end_date");
    const xAxisJobCode = JSON.parse(this.data.get("x_axis_job_code"));
    const xAxisJob = JSON.parse(this.data.get("x_axis_job"));
    const xAxisBluePrintCode = JSON.parse(this.data.get("x_axis_blue_print_code"));
    const xAxisBluePrint = JSON.parse(this.data.get("x_axis_blue_print"));
    const xAxisConstructionCode = JSON.parse(this.data.get("x_axis_construction_code"));
    const xAxisConstruction = JSON.parse(this.data.get("x_axis_construction"));
    const xAxisNonConstructionCode = JSON.parse(this.data.get("x_axis_non_construction_code"));
    const xAxisNonConstruction = JSON.parse(this.data.get("x_axis_non_construction"));
    const currentUserCompaniesShortNames = JSON.parse(this.data.get("current_user_companies_short_names"));
    const dayRateData = JSON.parse(this.data.get("day_rate"));
    const dayRateDataRef = this.data.get("day_rate_ref");
    const planningDayUnapprovedRateData = JSON.parse(this.data.get("planning_day_unapproved_rate"));
    const planningDayRateData = JSON.parse(this.data.get("planning_day_rate"));
    const planningDayRateDataRef = this.data.get("planning_day_rate_ref");
    const buildingDayUnapprovedRateData = JSON.parse(this.data.get("building_day_unapproved_rate"));
    const buildingDayRateData = JSON.parse(this.data.get("building_day_rate"));
    const buildingDayRateDataRef = this.data.get("building_day_rate_ref");
    const nonConstructionDayUnapprovedRateData = JSON.parse(this.data.get("non_construction_day_unapproved_rate"));
    const nonConstructionDayRateData = JSON.parse(this.data.get("non_construction_day_rate"));

    const day_option = {
        title: {
          text: '工作填报率'
        },
        grid: {
          left: 50,
          right: 110,
          top: 60,
          bottom: 60
        },
        toolbox: {
          feature: {
            dataView: {},
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {},
        xAxis: {
          data: xAxisJob,
          silent: true,
          axisLabel: {
            interval: 0,
            rotate: -40
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} %'
          },
          min: 0,
          max: 120,
        },
        series: [{
          name: '工作填报率',
          type: 'line',
          symbol: 'triangle',
          symbolSize: function(val) {
            if (val < dayRateDataRef) {
              return 8;
            } else {
              return 16;
            }
          },
          data: dayRateData,
          itemStyle: {
            color: '#738496'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%'
          },
          markLine: {
            label: {
              formatter: '{c}% 填报率及格线'
            },
            lineStyle: {
              type: 'solid',
              width: 1
            },
            data: [
              {
                yAxis: dayRateDataRef
              }
            ]
          }
        }]
    };

    const planning_day_option = {
        title: {
          text: '方案饱和度'
        },
        grid: {
          left: 50,
          right: 110,
          top: 60,
          bottom: 125
        },
        toolbox: {
          feature: {
            dataView: {},
            saveAsImage: {
                pixelRatio: 2
            }
          }
        },
        tooltip: {},
        xAxis: {
          data: xAxisBluePrint,
          silent: true,
          axisLabel: {
            interval: 0,
            rotate: -40
          },
          splitLine: {
              show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} %'
          },
          min: 0,
          max: 120,
        },
        legend: {
            data: ['方案饱和度（含未审核工时）','方案饱和度'],
            align: 'left'
        },
        series: [{
          name: '方案饱和度（含未审核工时）',
          type: 'line',
          symbol: 'circle',
          symbolSize: function(val) {
            if (val < planningDayRateDataRef) {
              return 8;
            } else {
              return 16;
            }
          },
          data: planningDayUnapprovedRateData,
          itemStyle: {
            color: '#69B0B8'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%'
          }
        },{
          name: '方案饱和度',
          type: 'line',
          symbol: 'circle',
          symbolSize: function(val) {
            if (val < planningDayRateDataRef) {
              return 8;
            } else {
              return 16;
            }
          },
          data: planningDayRateData,
          itemStyle: {
            color: '#334B5C'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%'
          },
          markLine: {
            label: {
              formatter: '{c}% 饱和度线'
            },
            lineStyle: {
              type: 'solid',
              width: 1
            },
            data: [
              {
                yAxis: planningDayRateDataRef
              }
            ]
          }
        }]
    };

    const building_day_option = {
        title: {
          text: '施工图饱和度'
        },
        grid: {
          left: 50,
          right: 110,
          top: 60,
          bottom: 125
        },
        toolbox: {
          feature: {
            dataView: {},
            saveAsImage: {
                pixelRatio: 2
            }
          }
        },
        tooltip: {},
        xAxis: {
          data: xAxisConstruction,
          silent: true,
          axisLabel: {
            interval: 0,
            rotate: -40
          },
          splitLine: {
              show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} %'
          },
          min: 0,
          max: 120,
        },
        legend: {
            data: ['施工图饱和度（含未审核工时）','施工图饱和度'],
            align: 'left'
        },
        series: [{
          name: '施工图饱和度（含未审核工时）',
          type: 'line',
          symbol: 'square',
          symbolSize:  function(val) {
            if (val < buildingDayRateDataRef) {
              return 8;
            } else {
              return 16;
            }
          },
          data: buildingDayUnapprovedRateData,
          itemStyle: {
            color: '#69B0B8'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%'
          }
        },{
          name: '施工图饱和度',
          type: 'line',
          symbol: 'square',
          symbolSize:  function(val) {
            if (val < buildingDayRateDataRef) {
              return 8;
            } else {
              return 16;
            }
          },
          data: buildingDayRateData,
          itemStyle: {
            color: '#334B5C'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%'
          },
          markLine: {
            label: {
              formatter: '{c}% 饱和度线'
            },
            lineStyle: {
              type: 'solid',
              width: 1
            },
            data: [
              {
                yAxis: buildingDayRateDataRef
              }
            ]
          }
        }]
    };

    const non_construction_option = {
        title: {
          text: '规划/景观/室内/VR饱和度'
        },
        grid: {
          left: 50,
          right: 110,
          top: 60,
          bottom: 60
        },
        toolbox: {
          feature: {
            dataView: {},
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {},
        xAxis: {
          data: xAxisNonConstruction,
          silent: true,
          axisLabel: {
            interval: 0,
            rotate: -40
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} %'
          }
        },
        legend: {
            data: ['规划/景观/室内/VR饱和度（含未审核工时）','规划/景观/室内/VR饱和度'],
            align: 'left'
        },
        series: [{
          name: '规划/景观/室内/VR饱和度（含未审核工时）',
          type: 'line',
          symbol: 'triangle',
          symbolSize: 12,
          data: nonConstructionDayUnapprovedRateData,
          itemStyle: {
            color: '#69B0B8'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%'
          }
        },{
          name: '规划/景观/室内/VR饱和度',
          type: 'line',
          symbol: 'triangle',
          symbolSize: 12,
          data: nonConstructionDayRateData,
          itemStyle: {
            color: '#738496'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%'
          }
        }]
    };

    function drill_down_subsidiary(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'line') {
          let orgcode;
          let company_name;
          switch (params.seriesName) {
            case '工作填报率':
              orgcode = xAxisJobCode[params.dataIndex]
              company_name = xAxisJob[params.dataIndex]
              break;
            case '方案饱和度':
              orgcode = xAxisBluePrintCode[params.dataIndex]
              company_name = xAxisBluePrint[params.dataIndex]
              break;
            case '施工图饱和度':
              orgcode = xAxisConstructionCode[params.dataIndex]
              company_name = xAxisConstruction[params.dataIndex]
              break;
            case '规划/景观/室内/VR饱和度':
              orgcode = xAxisNonConstructionCode[params.dataIndex]
              company_name = xAxisNonConstruction[params.dataIndex]
              break;
          }

          if (!orgcode) return;

          let url = '/report/subsidiary_daily_workloading';

          url += '?orgcode=' + encodeURIComponent(orgcode) + '&begin_date=' + beginDate + '&end_date='+ endDate + '&view_deptcode_sum=true';

          if (currentUserCompaniesShortNames.indexOf(company_name) > -1 || currentUserCompaniesShortNames.indexOf('上海天华') > -1) {
            Turbolinks.visit(url);
          }
        }
      }
    }

    groupDailyWorkloadingsDayChart.setOption(day_option, false);
    groupDailyWorkloadingsDayChart.on('click', drill_down_subsidiary);
    groupDailyWorkloadingsPlanningDayChart.setOption(planning_day_option, false);
    groupDailyWorkloadingsPlanningDayChart.on('click', drill_down_subsidiary);
    groupDailyWorkloadingsBuildingDayChart.setOption(building_day_option, false);
    groupDailyWorkloadingsBuildingDayChart.on('click', drill_down_subsidiary);
    groupDailyWorkloadingsNonConstructionDayChart.setOption(non_construction_option, false);
    groupDailyWorkloadingsNonConstructionDayChart.on('click', drill_down_subsidiary);
    setTimeout(() => {
      groupDailyWorkloadingsDayChart.resize();
      groupDailyWorkloadingsPlanningDayChart.resize();
      groupDailyWorkloadingsBuildingDayChart.resize();
      groupDailyWorkloadingsNonConstructionDayChart.resize();
    }, 200);
  }

  layout() {
    groupDailyWorkloadingsDayChart.resize();
    groupDailyWorkloadingsPlanningDayChart.resize();
    groupDailyWorkloadingsBuildingDayChart.resize();
    groupDailyWorkloadingsNonConstructionDayChart.resize();
  }

  disconnect() {
    groupDailyWorkloadingsDayChart.dispose();
    groupDailyWorkloadingsPlanningDayChart.dispose();
    groupDailyWorkloadingsBuildingDayChart.dispose();
    groupDailyWorkloadingsNonConstructionDayChart.dispose();
  }
}
